import React from "react";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import PNotify from "pnotify/dist/es/PNotify";
import {clientAp, postLotto99} from "../../constants/general";
import {fetchUserBalance, getRecentSize, setRecentSize} from "../../store/user/action";
import {showErrorMessage} from "../lo5d/showErrorMessage";
import {Lotto99Context} from "../../store/lotto99/Lotto99Context";
import {playAudio} from "../../store/audio/action";
import {currentDate} from "../../utils/dateUtils";
import {
    clearAllInv,
    fetchLO99DrawingResult,
    fetchLO99RecentDraw, fetchLotto99RecentTicket, fetchLotto99ResultReport,
    fetchLotto99WinLossReport,
    createBetting,
    drawingNumber
} from "../../store/lotto99/action";
import {SUBSCRIPTION_LOTTO99} from "../../constants/lotto99";


// ---- local initial states ----
const initBet = {
    listBetting: [],
    postBetting: [],
    rangeBetting: [],
};

const initFields = {
    betAmount: 0,
    numberFrom: "",
    numberTo: "",
    betLogs: [],
};

class MainLotto99Wrapper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // drawing status
            status: null,

            // betting state
            id: "",
            betTypes: [
                {id: "NORMAL", title: "ធម្មតា", checked: true},
                {id: "RANGE", title: "អូស", checked: false}
            ],
            activeBetType: "NORMAL",
            betting: {...initBet},
            fields: {...initFields},
            isBetting: false,
            posts: [...postLotto99],
            // which field numpad is writing to: 'from' | 'to' | 'amount'
            activeNumberField: "from",
            page: 1,
            date: currentDate(),
            isShow: false,
            dataDetail: null,
            size: getRecentSize().lo90,
            isNewFormat: true
        };
    }


    componentDidMount() {
        this.subscription();
        this.refreshData();
        this.props.fetchLO99RecentDraw();
    }
    refreshData = () => {
        const {
            fetchLO99DrawingResult,
            fetchUserBalance,
            fetchLotto99RecentTicket
        } = this.props;
        fetchLotto99RecentTicket({size: getRecentSize().lo99})
        fetchLO99DrawingResult();
        fetchUserBalance();
    }

    componentWillUnmount() {
        this.sub && this.sub.unsubscribe();
        clearAllInv();
    }

    onDrawStatusChange = (currentDraw) => {
        const {status} = this.state;
        if (currentDraw.status !== status) {
            if (status && currentDraw.status === "OPEN") {
                this.refreshData();
                this.props.fetchLO99RecentDraw(10, false);
            }
            if (status && currentDraw.status === "RELEASE") {
                this.props.fetchLO99DrawingResult();
                this.props.fetchLO99RecentDraw(9, false);
            }
            this.setState({status: currentDraw.status})
        }

    }

    subscription = () => {
        this.sub = clientAp.subscribe({
            query: SUBSCRIPTION_LOTTO99,
        }).subscribe({
            next: (event) => {
                if (event.data && event.data.v_lotto99_drawing) {
                    let currentDraw = event.data.v_lotto99_drawing[0] || {};
                    this.onDrawStatusChange(currentDraw);
                }
            },
            error: (err) => {
                console.error("err", err);
            }
        });
    }

    isBet = () =>
        document.location.pathname === "/lottery1/99"


    playSound = (src) => {
        const {audio} = this.props;
        if (audio && !audio.isMute) {
            playAudio(src);
        }
    };


    onFilter = () => {
        this.setState({imageRotate: "rotate"})
        this.props.fetchLotto99RecentTicket({size: this.state.size}).then(() => {
            setTimeout(() => {
                this.setState({imageRotate: ""})
            }, 300)
        }).catch(() => {
            setTimeout(() => {
                this.setState({imageRotate: ""})
            }, 300)
        })
    }

    onChangeSize = (size) => {
        this.setState({size: size});
        setRecentSize({lo90: size});
    }


    onShowDetail = (item) => {
        this.setState({
            isShow: true,
            dataDetail: item
        });
    }

    onCloseDetail = () => {
        this.setState({
            isShow: false,
            dataDetail: null
        });
    }


    // ---------- helpers ----------

    handleChangeNumberFrom = (e) => {
        const value = e.target.value;
        this.setState((prev) => ({
            ...prev,
            fields: {
                ...prev.fields,
                numberFrom: value,
            },
        }));
    };


    handleChangeNumberTo = (e) => {
        const value = e.target.value;
        this.setState((prev) => ({
            ...prev,
            fields: {
                ...prev.fields,
                numberTo: value,
            },
        }));
    };


    handleChangeBetAmount = (e) => {
        const value = e.target.value;
        this.setState((prev) => ({
            ...prev,
            fields: {
                ...prev.fields,
                betAmount: value === "" ? "" : parseInt(value || 0, 10),
            },
        }));
    };


    // Use =====================

    getSelectedPost = () =>
        this.state.posts.filter((p) => p.checked).map((p) => p.id);

    // toggle posts + ALL
    handlePostCheckChange = (name) => {
        this.setState((prev) => {
            if (name === "all") {
                const allChecked = prev.posts.every((p) => p.checked);
                return {
                    posts: prev.posts.map((p) => ({...p, checked: !allChecked})),
                };
            }

            return {
                posts: prev.posts.map((p) =>
                    p.id === name ? {...p, checked: !p.checked} : p
                ),
            };
        });
    };

    // bet type buttons
    handleBetTypeChange = (id) => {
        this.setState((prev) => ({
            activeBetType: id,
            fields: {
                ...prev.fields,
                numberFrom: "",
                numberTo: "",
            },
            activeNumberField: "from",
        }));
    };

    // which input numpad is targeting
    setActiveNumberField = (field) => {
        this.setState({activeNumberField: field});
    };

    // numpad 0–9
    handleDigitClick = (digit) => {
        this.setState((prev) => {
            const {activeNumberField, fields} = prev;

            // decide which field to update
            const fieldName =
                activeNumberField === "to"
                    ? "numberTo"
                    : activeNumberField === "amount"
                        ? "betAmount"
                        : "numberFrom";

            const current = (fields[fieldName] || "").toString();
            const maxLen = fieldName === "betAmount" ? 9 : 2; // 2 digits for numbers, more for amount

            // already at max length → ignore
            if (current.length >= maxLen) return null;

            const next = current + String(digit);

            // 🔹 betAmount: no special validation, just update
            if (fieldName === "betAmount") {
                return {
                    fields: {
                        ...fields,
                        betAmount: next,
                    },
                };
            }

            // 🔹 numberFrom / numberTo: validate only when we have 2 digits
            if (next.length === 2) {
                const num = parseInt(next, 10);

                // block 00, <01 or >99
                if (!Number.isFinite(num) || num < 1 || num > 99) {
                    // invalid → do not change state
                    return null;
                }
            }

            // allow intermediate values like "0" so user can type "01"
            return {
                fields: {
                    ...fields,
                    [fieldName]: next,
                },
            };
        });
    };

    // clear a single field
    clearField = (field) => {
        this.setState((prev) => ({
            fields: {
                ...prev.fields,
                [field]: "",
            },
        }));
    };

    // for manual typing in InputNumber or amount
    handleChangeField = (field, value) => {
        this.setState((prev) => ({
            fields: {
                ...prev.fields,
                [field]: value,
            },
        }));
    };

    // price buttons from config.lotto99PackagePrices
    handlePriceClick = (price) => {
        this.setState((prev) => {
            const current = parseInt(prev.fields.betAmount || 0, 10);
            const nextAmount = current + price.value;

            return {
                fields: {
                    ...prev.fields,
                    betAmount: String(nextAmount),
                    betLogs: [...prev.fields.betLogs, String(price.value)],
                },
            };
        });
    };

    // reset everything
    resetBet = () => {
        this.setState((prev) => ({
            posts: prev.posts.map((p) => ({...p, checked: false})),
            activeBetType: "NORMAL",
            fields: {
                numberFrom: "",
                numberTo: "",
                betAmount: "",
                betLogs: [],
            },
            activeNumberField: "from",
        }));
    };

// build items & validate
    buildItems = () => {
        const {t, user} = this.props;
        const {activeBetType, fields} = this.state;

        const selectedPosts = this.getSelectedPost();
        const currencyCode = user?.userBalance?.currencyCode || "KHR";

        const numberFrom = fields.numberFrom.trim();
        const numberTo = fields.numberTo.trim();
        const betAmountInt = parseInt(fields.betAmount || 0, 10);

        const pad2 = (n) => n.toString().padStart(2, "0");
        const toInt = (v) => parseInt(v || "0", 10);

        // helper: check valid Lotto99 number
        const isValidLottoNum = (v) => {
            const n = toInt(v);
            return n >= 1 && n <= 99; // reject 00 and >99
        };

        // ===== basic validation =====

        if (!selectedPosts.length) {
            PNotify.info({
                title: t("messages:sale.error.title"),
                text: t("messages:sale.error.post_required"),
            });
            return null;
        }

        // amount required
        if (!betAmountInt || betAmountInt <= 0) {
            PNotify.info({
                title: t("messages:sale.error.title"),
                text: t("messages:sale.error.bet_amount_required"),
            });
            return null;
        }

        // amount validation
        if (currencyCode === "KHR") {
            if (betAmountInt < 100) {
                PNotify.info({
                    title: t("messages:sale.error.title"),
                    text: t("messages:sale.error.bet_amount_min_required"),
                });
                return null;
            }
            if (betAmountInt % 100 !== 0) {
                PNotify.info({
                    title: t("messages:sale.error.title"),
                    text: t("messages:sale.error.bet_amount_in_valid"),
                });
                return null;
            }
        } else if (currencyCode === "USD") {
            if (betAmountInt < 1) {
                PNotify.info({
                    title: t("messages:sale.error.title"),
                    text: t("messages:sale.error.bet_amount_min_required"),
                });
                return null;
            }
        }

        // ===== NORMAL BET VALIDATION =====
        if (activeBetType === "NORMAL") {
            if (!isValidLottoNum(numberFrom)) {
                PNotify.info({
                    title: t("messages:sale.error.title"),
                    text: t("messages:sale.error.bet_number_invalid"),
                });
                return null;
            }
        }

        // ===== RANGE BET VALIDATION =====
        if (activeBetType === "RANGE") {
            if (!numberFrom || !numberTo) {
                PNotify.info({
                    title: t("messages:sale.error.title"),
                    text: t("messages:sale.error.bet_number_invalid"),
                });
                return null;
            }

            const fromNum = toInt(numberFrom);
            const toNum = toInt(numberTo);

            // must be valid lotto numbers
            if (!isValidLottoNum(numberFrom) || !isValidLottoNum(numberTo)) {
                PNotify.info({
                    title: t("messages:sale.error.title"),
                    text: t("messages:sale.error.bet_number_invalid"),
                });
                return null;
            }

            // to > from only
            if (toNum <= fromNum) {
                PNotify.info({
                    title: t("messages:sale.error.title"),
                    text: t("messages:sale.error.bet_number_invalid"),
                });
                return null;
            }
        }

        // convert posts
        const postsString = selectedPosts.join("");

        // bet log format
        const betLogStr =
            fields.betLogs && fields.betLogs.length
                ? fields.betLogs.join(",")
                : null;

        // ===== BUILD ITEMS =====
        let items = [];

        if (activeBetType === "NORMAL") {
            items.push({
                betTypeCode: "NORMAL",
                betTitle: "NORMAL",
                posts: postsString,
                numberFrom: pad2(toInt(numberFrom)),
                numberTo: "",
                amount: betAmountInt,
                betLog: betLogStr,
            });
        }

        if (activeBetType === "RANGE") {
            items.push({
                betTypeCode: "RANGE",
                betTitle: "RANGE",
                posts: postsString,
                numberFrom: pad2(toInt(numberFrom)),
                numberTo: pad2(toInt(numberTo)),
                amount: betAmountInt,
                betLog: betLogStr,
            });
        }

        return items;
    };

    // submit to API
    handleSubmitBetting = () => {

        const {
            t,
            drawing: {newResult},
            createBetting,
            fetchUserBalance,
            fetchLotto99RecentTicket,
        } = this.props;

        const {isBetting} = this.state;

        if (!newResult || !newResult.drawCode) {
            PNotify.info({
                title: t("messages:error"),
                text: t("messages:sale.error.bet_number_invalid"),
            });
            return;
        }

        if (isBetting) return;

        const items = this.buildItems();
        if (!items || !items.length) return;

        this.setState({isBetting: true});

        createBetting({
            drawCode: newResult?.drawCode,
            items,
        })
            .then(() => {
                this.setState((prev) => ({
                    isBetting: false,
                    posts: prev.posts.map((p) => ({...p, checked: false})),
                    activeBetType: "NORMAL",
                    fields: {
                        numberFrom: "",
                        numberTo: "",
                        betAmount: "",
                        betLogs: [],
                    },
                    activeNumberField: "from",
                }));

                fetchUserBalance && fetchUserBalance();
                fetchLotto99RecentTicket &&
                fetchLotto99RecentTicket({size: getRecentSize().lo99})

                PNotify.removeAll();
                PNotify.success({
                    title: t("messages:success"),
                    text: t("messages:sale.success"),
                });
            })
            .catch((error) => {
                this.setState({isBetting: false});
                console.log("error", error)
                error && showErrorMessage(error, t);
            });
    };


    /* =========================
     *   RENDER / CONTEXT VALUE
     * ========================= */

    render() {
        const {children, t, config, user, i18n, drawing, tickets, lastResult, list, status, oldResult} = this.props;
        const {
            betType,
            activeBetType,
            betTypes,
            betting,
            fields,
            postGroup,
            isBetting,
            posts,
            activeNumberField,
            size,
            isShow,
            dataDetail
        } =
            this.state;


        const contextValue = {
            // from wrapper state
            t,
            config,
            user,
            status,
            betType,
            betting,
            fields,
            postGroup,
            isBetting,
            tickets,
            size,
            isShow,
            dataDetail,
            lastResult,
            posts,
            betTypes,
            activeBetType,
            drawing,
            i18n,
            activeNumberField,
            list, oldResult,
            ...this.props,

            // handlers for mobile board:
            handleChangeNumberFrom: this.handleChangeNumberFrom,
            handleChangeNumberTo: this.handleChangeNumberTo,
            handleChangeBetAmount: this.handleChangeBetAmount,
            handleBetTypeChange: this.handleBetTypeChange,
            playSound: this.playSound,
            handlePostCheckChange: this.handlePostCheckChange,
            handleDigitClick: this.handleDigitClick,
            setActiveNumberField: this.setActiveNumberField,
            getSelectedPost: this.getSelectedPost,
            clearField: this.clearField,
            handleChangeField: this.handleChangeField,
            handlePriceClick: this.handlePriceClick,
            handleSubmitBetting: this.handleSubmitBetting,
            resetBet: this.resetBet,
            onFilter: this.onFilter,
            onChangeSize: this.onChangeSize,
            onShowDetail: this.onShowDetail,
            onCloseDetail: this.onCloseDetail

        };

        return (
            <Lotto99Context.Provider value={contextValue}>
                {children}
            </Lotto99Context.Provider>
        );
    }
}

const mapStateToProps = (state) => ({
    ...state.lotto99,
    config: state.config,
    audio: state.audio,
    user: state.user,
    drawing: state.lotto99.drawing,
    list: state.lotto99.recentDraw.list,
});

export default connect(mapStateToProps, {
    fetchLotto99WinLossReport,
    fetchLO99DrawingResult,
    fetchLO99RecentDraw,
    fetchUserBalance,
    clearAllInv,
    drawingNumber,
    fetchLotto99RecentTicket,
    fetchLotto99ResultReport,
    createBetting
})(withTranslation()(MainLotto99Wrapper));
